module.exports = __webpack_public_path__ + "86d1a75b0e98a0d72954a97eef245839.svg";